import semver from 'semver';

import metadata from '@/../package.json';
/**
 * Generates a URL to the Anchore documentation site, optionally with a path
 * When uiVersion is available, it will be used to determine the version of the
 * documentation to link to. If not, it will default to the 'current' version.
 * @param path
 * @returns docs URL
 */
export const getDocsUrl = (path?: string): string => {
  // eslint-disable-next-line local-rules/no-hardcoded-documentation-urls
  const baseDocsUrl = 'https://docs.anchore.com';
  const uiVersion = process.env.BROWSER
    ? window.App.uiVersion
    : metadata.version;

  const docsVersion =
    uiVersion && semver.valid(uiVersion)
      ? `${semver.major(uiVersion)}.${semver.minor(uiVersion)}`
      : 'current';

  // Start with the base URL including version
  const baseUrl = new URL(`/${docsVersion}/`, baseDocsUrl);

  if (path) {
    // Parse the input path to handle pathname and hash separately
    const inputUrl = new URL(path, 'http://placeholder.com');

    // Clean up the pathname: normalize slashes and remove leading/trailing slashes
    const cleanedPathname = inputUrl.pathname
      .replace(/\/+/g, '/')
      .replace(/^\/|\/$/g, '');

    // Create the final URL
    const finalUrl = new URL(baseDocsUrl);
    // Build the final pathname with trailing slash
    finalUrl.pathname = `/${docsVersion}/${cleanedPathname}/`;
    if (inputUrl.hash) {
      // Remove any trailing slash from the hash
      finalUrl.hash = inputUrl.hash.replace(/\/$/, '');
    }

    return finalUrl.toString();
  }

  return baseUrl.toString();
};
